import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Input, Label, ScannerCode, Select, SelectJustification, SelectPrintType, SelectResource } from '../../../../components/UI/ComponentsUI';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import { convertToUppercase, translate } from '../../../../utils/util';
import { getVision } from '../../../../services/auth';

const DropMaterialBarCode = (props) => {
    const onChange = (event) => {
        props.onChange(event);
    };

    const onChangeToUpper = (event) => {
        convertToUppercase(event)
        props.onChange(event);
    }

    const scannerBarCode = (value) => {
        props.filter.cim = value;
        props.setFilter({ ...props.filter });
    };

    return (
        <div className='row'>
            <div className="input-field col s6 no-padding m5">
                <SelectPrintType
                    required
                    onChange={onChange}
                    value={props.filter?.print || ""}
                />
            </div>
            <div className="input-field no-padding col s5">
                <SelectResource
                    loadConfigLaser={getVision() === VISIONS.Jeep}
                    name="resourceId"
                    id="resourceId"
                    required={props.filter.print === ENUMS.ePrintTypes.Logistics.value || props.filter.print === ENUMS.ePrintTypes.Click.value}
                    value={props.filter?.resourceId}
                    onChange={onChange} />
            </div>
            <div className="input-field col s6 no-padding m6">
                {
                    props.disable ?
                        <Label
                            label={translate('stock:cim')}
                            id="cim"
                            name="cim"
                            value={props.filter?.cim} /> :
                        <>
                            <Input
                                disabled={props.disable}
                                required
                                label={translate('stock:cim')}
                                id="cim"
                                name="cim"
                                type="text"
                                maxLength={10}
                                onChange={onChangeToUpper}
                                value={props.filter?.cim}
                            />
                            <ScannerCode onScanner={scannerBarCode} />
                        </>
                }
            </div>
            <div className="input-field col s5 no-padding m5" >
                <Input
                    label={translate('stock:quantity')}
                    id="quantity"
                    name="quantity"
                    type="number"
                    onChange={onChange}
                    defaultValue={props.filter?.quantity}
                />
            </div>
            {!props.pabReplanning &&
                <div>
                    <div className="input-field no-padding  col s12">
                        <Select
                            required
                            id="masterCim"
                            name="masterCim"
                            display="name"
                            label={translate('stock:write-off-master-cim')}
                            placeHolder={translate('choose-one-option', 'general')}
                            data={[
                                { id: "S", text: translate('stock:yes') },
                                { id: "N", text: translate('stock:no') }
                            ]}
                            change={onChange}
                            defaultValue={props.filter?.masterCim || ""}
                        />
                    </div>
                    <div className="input-field no-padding col s12" >
                        <SelectJustification
                            required
                            type={6}
                            onChange={onChange}
                            value={props.filter?.justification || ''}
                        />
                    </div>
                </div>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DropMaterialBarCode));